<template>
  <div class="page-container">
    <el-card shadow="never" class="page-card">
      <div class="filter-bar">
        <div class="filter-hint">每个档位可单独开启「自动到账」：开启后用户申请该档位将异步自动审核打款</div>
        <div class="action-group">
          <el-button type="primary" icon="el-icon-plus" @click="openAdd">新增档位</el-button>
          <el-button icon="el-icon-refresh" @click="fetchList">刷新</el-button>
        </div>
      </div>

      <div v-if="error" class="error">{{ error }}</div>
      <el-empty v-else-if="!loading && tableData.length === 0" description="暂无提现档位，请先新增" />

      <el-table
        v-else
        :data="tableData"
        border
        stripe
        v-loading="loading"
        element-loading-text="加载中..."
        row-key="id"
      >
        <el-table-column prop="id" label="ID" min-width="80" align="center" />
        <el-table-column label="金额(元)" min-width="120" align="center">
          <template slot-scope="scope">
            {{ formatYuan(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="金币" min-width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.amount }}
          </template>
        </el-table-column>
        <el-table-column label="自动到账" min-width="120" align="center">
          <template slot-scope="scope">
            <el-tag v-if="Number(scope.row.autoPayout) === 1" type="success" size="small">开</el-tag>
            <el-tag v-else type="info" size="small">关</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="排序" min-width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.sortOrder != null ? scope.row.sortOrder : 0 }}
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="100" align="center">
          <template slot-scope="scope">
            <el-tag v-if="Number(scope.row.status) === 1" type="success" size="small">启用</el-tag>
            <el-tag v-else type="info" size="small">禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="180" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="openEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog
      :title="dialogMode === 'add' ? '新增提现档位' : '编辑提现档位'"
      :visible.sync="dialogVisible"
      width="460px"
      center
      append-to-body
    >
      <el-form ref="formRef" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="金额(元)" prop="amountYuan">
          <el-input-number
            v-model="form.amountYuan"
            :min="0.01"
            :max="1000000"
            :step="0.1"
            :precision="2"
            controls-position="right"
            style="width:100%;"
          />
        </el-form-item>
        <el-form-item label="自动到账" prop="autoPayout">
          <el-switch
            v-model="form.autoPayout"
            :active-value="1"
            :inactive-value="0"
            active-text="开"
            inactive-text="关"
          />
        </el-form-item>
        <el-form-item label="排序" prop="sortOrder">
          <el-input-number
            v-model="form.sortOrder"
            :min="0"
            :max="999999"
            :step="1"
            controls-position="right"
            style="width:100%;"
          />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { get, post, put, del } from '@/utils/http'

export default {
  name: 'WithdrawalOptionManagement',
  data() {
    return {
      loading: false,
      submitLoading: false,
      error: '',
      tableData: [],
      dialogVisible: false,
      dialogMode: 'add',
      form: {
        id: null,
        amountYuan: 1,
        autoPayout: 0,
        sortOrder: 0,
        status: 1
      },
      rules: {
        amountYuan: [{ required: true, message: '请输入金额', trigger: 'change' }],
        autoPayout: [{ required: true, message: '请选择是否自动到账', trigger: 'change' }]
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    formatYuan(row) {
      if (row.amountYuan !== undefined && row.amountYuan !== null) {
        return Number(row.amountYuan).toFixed(2)
      }
      const coin = Number(row.amount || 0)
      return (coin / 1000).toFixed(2)
    },
    async fetchList() {
      this.loading = true
      this.error = ''
      try {
        const res = await get('/admin/withdrawalOptions/list')
        this.tableData = (res && res.data) || []
      } catch (e) {
        this.error = e.message || '获取提现档位失败'
        this.tableData = []
      } finally {
        this.loading = false
      }
    },
    openAdd() {
      this.dialogMode = 'add'
      this.form = {
        id: null,
        amountYuan: 1,
        autoPayout: 0,
        sortOrder: this.tableData.length + 1,
        status: 1
      }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    openEdit(row) {
      this.dialogMode = 'edit'
      this.form = {
        id: row.id,
        amountYuan: row.amountYuan != null ? Number(row.amountYuan) : Number(row.amount || 0) / 1000,
        autoPayout: Number(row.autoPayout) === 1 ? 1 : 0,
        sortOrder: row.sortOrder != null ? row.sortOrder : 0,
        status: Number(row.status) === 0 ? 0 : 1
      }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    submitForm() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.submitLoading = true
        try {
          const payload = {
            amountYuan: this.form.amountYuan,
            autoPayout: this.form.autoPayout,
            sortOrder: this.form.sortOrder,
            status: this.form.status
          }
          if (this.dialogMode === 'add') {
            await post('/admin/withdrawalOptions', payload)
            this.$message.success('新增成功')
          } else {
            await put(`/admin/withdrawalOptions/${this.form.id}`, payload)
            this.$message.success('保存成功')
          }
          this.dialogVisible = false
          await this.fetchList()
        } catch (e) {
          this.$message.error(e.message || '保存失败')
        } finally {
          this.submitLoading = false
        }
      })
    },
    handleDelete(row) {
      this.$confirm(`确定删除档位 ¥${this.formatYuan(row)} 吗？`, '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          await del(`/admin/withdrawalOptions/${row.id}`)
          this.$message.success('已删除')
          await this.fetchList()
        } catch (e) {
          this.$message.error(e.message || '删除失败')
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.page-container {
  padding: 0;
}
.page-card {
  border: none;
}
.filter-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
}
.filter-hint {
  color: #64748b;
  font-size: 13px;
  line-height: 1.5;
}
.action-group {
  display: flex;
  gap: 8px;
}
.error {
  color: #f56c6c;
  padding: 12px 0;
}
</style>
